/** 소셜 국제번호(+82 10-...)와 직접 입력 번호를 국내 숫자 형식으로 통일한다. */
export function normalizeSignupPhone(value?: string): string {
    const digits = (value ?? '').replace(/\D/g, '');
    return digits.startsWith('82') ? '0' + digits.slice(2).replace(/^0/, '') : digits;
}
